import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { getPostLoginPath } from "../../utilities/postLoginRoute";

/**
 * PublicRoute component that redirects authenticated users away from
 * public routes like login and OTP verification
 */
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  const location = window.location.pathname;

  // Special case: Allow access to OTP page even when authenticated but without a role
  // This handles the flow from login -> OTP verification
  if (location === "/otp" && user && !user.user_type) {
    return children;
  }

  if (user) {
    return <Navigate to={getPostLoginPath(user.user_type)} replace />;
  }

  return children;
};

export default PublicRoute;
